import {
  Box,
  Container,
  Divider,
  List,
  ListItem,
  Stack,
  styled,
  Typography,

  Card,
  CardContent,

} from "@mui/material";

import feestructure from "../../assets/pdfs/admission/Fee Structure.pdf"

const data = {
  Overview: [
    {
      type: "para",
      data: "It is a four and half year full time programme consisting of classroom teaching, self-academic activities and clinical postings, with self-directed evidence based practice. The curriculum is planned to train the students to perfect professional with complete knowledge in theory, practical and clinical reasoning, diagnosis and treatment.",
    },
  ],
  "Eligibility Criteria": [
    {
      type: "unordered-list",
      data: {
        1: "Admission eligibility for this course is passing of 12th standard examination of Maharashtra Higher Secondary School Board (H.S.C.) or equivalent with English, Physics, Chemistry, and Biology (Botany & Zoology) subjects.",
        2: "Admissions are centrally carried out through a Common Entrance Test, NEET (National Eligibility & Entrance Test). Admission to course is on the basis of merit; according to the results of the NEET examination",
      },
    },
  ],

  "Admission Process": [
    {
      type: "unordered-list",
      data: {
        "1": "Admissions are centralised through the Directorate of Medical Education and Research, Mumbai, under the Maharashtra Govt.",
        "2": "After the NEET result is declared, registration to the government website is mandatory.",
        "3": "Candidates apply to the college through the preference forms available on the DMER website.",
        "4": "Based on their preference, eligible candidates' names are assigned to the college.",
        "5": "Candidates confirm their admission by duly filling the college form issued with the prospectus.",
        "6": "The process is completed with providing the necessary, original documentation to the college.",
        "7": "Fees are to be paid in full at the time of admission.",
      },
    },
    {
      type: "para",
      data: "Admissions take place through NEET counselling rounds only, unless specified otherwise by the DMER and/or MUHS.",
    },
  ],
  "Documents Required": [
    {
      type: "ordered-list",
      data: {
        "1": "NEET Admit Card of UG Exam",
        "2": "NEET Score Card/Marklist",
        "3": "Online Application (Registration) Form filled on mahacet.org.",
        "4": "Allotment Letter/Selection Letter issued from DMER.",
        "5": "Nationality Certificate issued by District Magistrate OR Attested Valid Indian Passport indicating the Nationality of the Candidate as 'INDIAN'",
        "6": "Domicile Certificate issued by District Magistrate endorsed with nationality as Indian on it.",
        "7": "SSC (Secondary) Statement of Mark Sheet.",
        "8": "SSC Passing Certificate",
        "9": "HSC (Higher Secondary) Statement of Mark Sheet.",
        "10": "HSC Passing Certificate",
        "11": "Aadhar Card Xerox",
        "12": "Caste Certificate",
        "13": "Caste Validity Certificate",
        "14": "Valid Non-Creamy Layer Certificate for VJ, NT-1, NT-2, NT-3, OBC, SBC (Valid up to 31/03/2023)",
        "15": "EWS Certificate with Income Certificate for A.Y 2022-2023",
        "16": "College Leaving Certificate (LC/TC)",
        "17": "Medical Fitness Certificate on Doctor's Letterhead (Annexure H format available in NEET UG 2022 Brochure)",
        "18": "Migration Certificate issued by the respective Board/University (If Applicable)",
        "19": "Affidavit Gap Certificate (If Applicable)",
        "20": "Hilly Area Certificate & Parents Domicile Certificate (If Applicable)",
        "21": "Copy of Gazette for Change in Name (If Applicable)",
        "22": "D1, D2, D3 Ex-serviceman certificate/Actual Service Certificate (If Applicable)",
        "23": "D1, D2 Domicile of Maharashtra certificate of Defence person (If Applicable)",
        "24": "D3 Transfer certificate and Domicile of other than Maharashtra certificate of parents (If Applicable)",
        "25": "D.D. in favor of PES Modern College of Physiotherapy, Pune-5",
      },
    },
  ],
  "Fee Structure": [
    {
      type: "pdf",
      // title: "BPT Fee Structure 2026-27",
      data: feestructure
    },
  ],
};

const RomanList = styled(List)(({ theme }) => ({
  listStyleType: "none",
  counterReset: "roman-counter",
  paddingLeft: 0,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up("md")]: {
    marginLeft: theme.spacing(10),
  },

  "& li": {
    counterIncrement: "roman-counter",
    position: "relative",
    paddingLeft: "48px",
    textIndent: "8px",
    marginBottom: theme.spacing(1),
  },
  "& li::before": {
    content: 'counter(roman-counter, upper-roman) ". "',
    position: "absolute",
    left: 0,
    top: "50%",
    transform: "translateY(-50%)",
    fontWeight: "bold",
    width: "auto",
    height: "auto",
    marginRight: "8px",
    textAlign: "right",
  },
}));

const AdmissionProcedureBPT = () => {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 2, md: 3 } }}
        spacing={2}
      >
        <Container sx={{ pt: 2 }}>
          {Object.entries(data).map(([section, items]) => {
            return (
              <div key={section} style={{ paddingTop: "16px" }}>
                <div style={{ marginBottom: "24px" }}>
                  <Typography
                    variant="h4"
                    gutterBottom
                    sx={{
                      display: "inline",
                      textDecoration: "underline",
                      textUnderlineOffset: "6px",
                    }}
                  >
                    {`${section}`}
                  </Typography>{" "}
                  <Typography
                    variant="h4"
                    sx={{ display: "inline" }}
                    gutterBottom
                  >
                    :
                  </Typography>
                </div>
                {items.map((item, index) => {
                  if (item.type === "para") {
                    return (
                      <Typography
                        key={index}
                        paragraph
                        fontSize={16}
                        sx={{ marginLeft: { sx: 2, md: 10 } }}
                      >
                        {typeof item.data === "string" ? item.data : ""}
                      </Typography>
                    );
                  } else if (item.type === "unordered-list") {
                    return (
                      <List
                        key={index}
                        sx={{
                          marginLeft: { sx: 2, md: 10 },
                          listStyleType: "none",
                          paddingLeft: 0,

                          "& li": {
                            position: "relative",
                            paddingLeft: "24px",
                          },
                          "& li::before": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "6px",
                            height: "6px",
                            borderRadius: "50%",
                            backgroundColor: "currentColor",
                          },
                        }}
                      >
                        {Object.values(item.data).map((listItem, i) => (
                          <ListItem
                            key={i}
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            {listItem}
                          </ListItem>
                        ))}
                      </List>
                    );
                  } else if (item.type === "ordered-list") {
                    return (
                      <RomanList key={item.type + index}>
                        {Object.values(item.data).map((listItem, i) => (
                          <ListItem key={i}>{listItem}</ListItem>
                        ))}
                      </RomanList>
                    );
                  } else if (item.type === "pdf") {
                    const pdfTitle =
                      "title" in item && typeof item.title === "string"
                        ? item.title
                        : undefined;
                    return (
                      <Box
                        key={index}
                        sx={{
                          width: "100%",
                          border: "1px solid #e0e0e0",
                          borderRadius: 2,
                          overflow: "hidden",
                        }}
                      >
                        {pdfTitle && (
                          <Typography
                            variant="h6"
                            sx={{
                              p: 2,
                              borderBottom: "1px solid #e0e0e0",
                              fontWeight: 600,
                            }}
                          >
                            {pdfTitle}
                          </Typography>
                        )}

                        <Box
                          sx={{
                            width: "100%",
                            height: {
                              xs: 400,
                              sm: 500,
                              md: 700,
                            },
                          }}
                        >
                          <iframe
                            src={item.data as string}
                            title={pdfTitle ?? ""}
                            width="100%"
                            height="100%"
                            style={{ border: "none" }}
                          />
                        </Box>
                      </Box>
                    );
                  } else {
                    return null;
                  }
                })}
                <Divider sx={{ marginY: 2 }} />
              </div>
            );
          })}
        </Container>
      </Stack>
    </Box>
  );
};

export default AdmissionProcedureBPT;
